import { render, staticRenderFns } from "./DomainLabel.vue?vue&type=template&id=901e947e&scoped=true&"
import script from "./DomainLabel.vue?vue&type=script&lang=js&"
export * from "./DomainLabel.vue?vue&type=script&lang=js&"
import style0 from "./DomainLabel.vue?vue&type=style&index=0&id=901e947e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "901e947e",
  null
  
)

export default component.exports